import { Box, Stack, styled } from '@ltvco/refresh-lib/theme';

export const NoResultsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6, 3),
  textAlign: 'center',
  maxWidth: 600,
  margin: '0 auto',
}));

export const NoResultsIcon = styled(Box)(({ theme }) => ({
  fontSize: '5rem',
  color: theme.palette.text.secondary,
  opacity: 0.7,
}));

export const NoResultsTipsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 450,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(3),
  backgroundColor: theme.palette.grey[50],
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
}));

export const NoResultsBullet = styled(Stack)(({ theme }) => ({
  width: '8px',
  color: theme.palette.primary.main,
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: theme.typography.body2.fontSize,
  lineHeight: 1,
}));
